import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useTranslation } from '@stepstone-platform/i18n';
import { Base, FormCheckbox, Stack, Text } from '@stepstone-genesis/components';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks.js';
import { keepMeInformedSelector, toggleKeepMeInformed, } from '../../registrationSlice.js';
export const KeepMeInformedCheckbox = () => {
    const { t } = useTranslation();
    const checkboxState = useAppSelector(keepMeInformedSelector);
    const dispatch = useAppDispatch();
    // TODO: what to do after the checkbox is clicked?
    const informMeToggle = () => dispatch(toggleKeepMeInformed());
    return (_jsx(Stack, { direction: ['vertical'], spacing: ['spaceS'], my: 'spaceS', children: _jsx(Base, { sx: { input: { margin: 'initial' } }, children: _jsx(FormCheckbox, { "data-testid": "keep-me-informed", checked: checkboxState, onChange: informMeToggle, size: ['medium'], isRequired: true, children: _jsx(Text, { fontSize: 'fontSizeS', color: 'colorGreyDark', children: t('loginregistration.registration.keepMeInformed') }) }) }) }));
};
//# sourceMappingURL=KeepMeInformedCheckbox.js.map